import { lazy } from 'react';

import { Code as CodeIcon } from '@mui/icons-material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { NavigationMenuCategory } from '~/src/app/components/Layout/components/NavigationMenu';

const APIConfig = lazy(() => import('./pages/APIConfig'));
const Webhooks = lazy(() => import('./pages/Webhooks'));

export const APIConfigRoutes = () => (
  <Routes>
    <Route element={<APIConfig />} path="api" />
    <Route element={<Webhooks />} path="webhooks" />
    <Route element={<Navigate to="api" />} path="*" />
  </Routes>
);

export const apiConfigNavigationCategory: NavigationMenuCategory = {
  icon: <CodeIcon color="secondary" />,
  items: [
    {
      name: 'apiConfig.items.webhooks',
      route: '/api-config/webhooks',
    },
    {
      name: 'apiConfig.items.devKeys',
      route: '/api-config/api',
    },
  ],
  name: 'apiConfig.title',
};
